import React, { useEffect, useState, FC } from "react";
import { Link, useHistory } from "react-router-dom";
import { Row, Col, Input, Button, Dropdown } from "antd";
import { ReactSVG } from "react-svg";
import { SearchOutlined } from "@ant-design/icons";
import SideBar from "./SideBar";
import SearchCard from "./SearchCard";
import _ from "lodash";
import { CopyPageModal, FilterByModal, ConfirmationModal } from "../../Modals";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import EditBioModal from "components/Modals/EditBioModal";
import FilterIcon from "assets/SVGs/FilterIcon";
import CompassIcon from "assets/SVGs/CompassIcon";
import { RootState } from "reducers/rootReducer";
import { getMembersPageListPath } from "../../../helpers/request/RequestPath";
import {
  getItemListRequestPayload,
  getMessageRequestPayload,
  getPageSearchArgument,
  wrapRequestPayload,
} from "../../../helpers/request/RequestPayload";
import useLocalStorageService from "../../../services/localStorage";
import { SocketTopics } from "constants/enums";
import {
  getModifyPageSubscriptionTopic,
  getPagesRequestPublishTopic,
  updatePagePublishTopic,
  getUserSubscriptionTopic,
} from "hooks/MQTTConstants";

let searchTimeout;

const SearchPanel: FC<{
  socket?: ISocket;
  callingPageId?: string;
  params: DashboardParams;
}> = ({ socket, callingPageId, params }) => {
  const { screens, setScreens } = params;
  const { searchResult, selectedItem, searchPage, focusItem } = useSelector(
    (state: RootState) => state.search
  );
  const dispatch = useDispatch();
  const [activeItem, setActiveItem] = useState(selectedItem);
  const [searchText, setSearchText] = useState<string>("");
  const { getLocalStorageItem } = useLocalStorageService();
  const [filter, setFilter] = useState({ offset: 0, limit: 10 });

  const [isFilterByModalVisible, setIsFilterByModalVisible] =
    useState<boolean>(false);

  const [isCopyModalVisible, setIsCopyModalVisible] = useState<any>();
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<any>();
  const [isLeaveModalVisible, setIsLeaveModalVisible] = useState<any>();

  const openInNewWindow = () => {
    window.open(
      window.location.origin + `/map/home`,
      "_blank",
      "toolbar=0,location=0,menubar=0"
    );
  };

  const menu = (
    <ul className="user-dropdown">
      <li>
        <Link to={`/map/home`} target="_blank" className="ml-3 text-white">
          Open New Tab
        </Link>
      </li>
      <li onClick={openInNewWindow}>
        <span className="ml-3">Open New Window</span>
      </li>
    </ul>
  );

  useEffect(() => {
    if (focusItem) {
      // console.log('focus item', focusItem);
      // handleSearchItemClick(focusItem, false);
      setActiveItem(focusItem);
    }
  }, [focusItem]);

  const handleSearchItemClick = (
    item: SelectedSearchItem,
    closeIframe = true
  ) => {
    setActiveItem(item);
    if (closeIframe) {
      setScreens({
        ...screens,
        map: true,
        message: true,
        rxPanel: false,
        ridePanel: false,
        iframe: false,
        active: "",
      });
    }
    console.log("handle search item click");
    dispatch({ type: "SET_SELECTED_ITEM", payload: item });
    dispatch({
      type: "SET_MESSAGE_FILTER",
      payload: [],
    });
    // setTimeout(()=>{
    //   socket.subscribeToEvent(
    //     SocketTopics.SubscribePageTopics,
    //     getUserSubscriptionTopic()
    //   );
    // }, 2000)
  };

  useEffect(() => {
    if (selectedItem) setActiveItem(selectedItem);
  }, [selectedItem]);

  const handleMapClick = () => {
    dispatch({ type: "SET_MAP_TYPE", payload: "HOME" });
    dispatch({
      type: "SET_ENABLED_FILTER",
      // payload: ["user", "page", "place", "asset", "media", "gps", "event"],
      payload: [],
    });
    dispatch({
      type: "SET_SELECTED_FILTER",
      payload: undefined,
    });
    setScreens({ ...screens, map: true });
  };

  const searchPageRequest = (search) => {
    setSearchText(search);
    if (searchTimeout) clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      // socket.publishToEvent(SocketTopics.PublishPageTopics, getPagesRequestPublishTopic(),
      //   wrapRequestPayload(getItemListRequestPayload([getMembersPageListPath(getLocalStorageItem('RID'))], '$', {limit: 20, offset: 0}, getPageSearchArgument((search && search !== '') ? search: undefined))),
      //  );

      //  console.log('search here', getPageSearchArgument((search && search !== '') ? search: undefined));

      console.log("search page request");
      dispatch({
        type: "SEARCH_PAGE",
        payload: { paginate: false, search, reset: true },
      });
    }, 1000);
  };

  const deletePage = (pageId) => {
    // const changes = [
    //   {
    //     op: "replace",
    //     path: "/objectStatus",
    //     value: "deleted",
    //   },
    // ];
    // socket.publishToEvent(
    //   SocketTopics.PublishPageTopics,
    //   updatePagePublishTopic(),
    //   wrapRequestPayload({ changes, objectId: pageId }, pageId),
    //   (data) => {
    //     if (!data.status) {
    //       console.log("Publish error: ", data.message);
    //     }
    //   }
    // );

    sendPageUpdateEvent(pageId, "deletePage", {});
  };

  const sendPageUpdateEvent = (pageId, type, attributes) => {
    const modifyPagePayload: IMessage = getMessageRequestPayload(
      localStorage.getItem("CID"),
      localStorage.getItem("RID"),
      pageId,
      "",
      type,
      attributes
    );
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getModifyPageSubscriptionTopic(pageId),
      wrapRequestPayload(modifyPagePayload)
    );
  };

  const removeUser = (pageId) => {
    sendPageUpdateEvent(pageId, "removePageMember", {
      userId: localStorage.getItem("RID"),
    });
  };

  return (
    <div className="main-column search-panel mr-4">
      <SideBar socket={socket} params={params} />
      <div className="main-content">
        <ReactSVG src="/images/next-icon.svg" className="main-next-icon" />
        <div className="search-bar">
          <div className="d-flex">
            <Input
              className="beam-input"
              onChange={(e) => {
                searchPageRequest(e.target.value);
              }}
              placeholder="Search Pages & Users"
              suffix={<SearchOutlined />}
            />
            <Button
              className="beam-btn ml-2"
              onClick={() => setIsFilterByModalVisible(true)}
            >
              <FilterIcon />
            </Button>
            {/* <Dropdown
              overlay={menu}
              placement="bottomRight"
              trigger={["contextMenu"]}
            > */}
            <Button className="beam-btn ml-2" onClick={handleMapClick}>
              <CompassIcon />
            </Button>
            {/* </Dropdown> */}
          </div>
          {isFilterByModalVisible && (
            <FilterByModal
              isModalVisible={isFilterByModalVisible}
              setIsModalVisible={setIsFilterByModalVisible}
              socket={socket}
            />
          )}

          {isCopyModalVisible !== undefined && (
            <CopyPageModal
              isModalVisible={isCopyModalVisible}
              setIsModalVisible={setIsCopyModalVisible}
              socket={socket}
            />
          )}

          {isDeleteModalVisible !== undefined && (
            <ConfirmationModal
              onClose={() => {
                setIsDeleteModalVisible(undefined);
              }}
              message={"Are you sure you want to delete page?"}
              handleConfirm={() => {
                deletePage(isDeleteModalVisible);
                // dispatch({
                //   type: "PAGE_REMOVE",
                //   payload: { pageId: isDeleteModalVisible },
                // });
                setIsDeleteModalVisible(undefined);
              }}
            />
          )}

          {isLeaveModalVisible !== undefined && (
            <ConfirmationModal
              onClose={() => {
                setIsLeaveModalVisible(undefined);
              }}
              message={"Are you sure you want to leave page?"}
              handleConfirm={() => {
                removeUser(isLeaveModalVisible);
                console.log("remove page here", isLeaveModalVisible);
                dispatch({
                  type: "PAGE_REMOVE",
                  payload: { pageId: isLeaveModalVisible },
                });
                setIsLeaveModalVisible(undefined);
              }}
            />
          )}
        </div>
        <div
          className="main-cards pt-2"
          onScroll={(e: any) => {
            const bottom =
              e.target.scrollHeight - e.target.scrollTop ===
              e.target.clientHeight;
            if (bottom && searchPage.scroll) {
              console.log("on scroll here");
              dispatch({ type: "SEARCH_PAGE", payload: { paginate: true } });
            }
          }}
        >
          {searchResult?.map((item: SelectedSearchItem, idx: number) => (
            <SearchCard
              item={item}
              key={idx}
              screens={screens}
              setScreens={setScreens}
              active={item.pageId === activeItem?.pageId}
              onClick={() => handleSearchItemClick(item)}
              calling={item?.nonpersistent?.dynamic?.live?.activeCall?.roomId}
              onCopy={(type, pageId) => {
                console.log("copy ", type, pageId);
                setIsCopyModalVisible({ type, pageId });
              }}
              onDelete={(pageId) => {
                setIsDeleteModalVisible(pageId);
              }}
              onLeave={(pageId) => {
                setIsLeaveModalVisible(pageId);
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SearchPanel;
